<template>
  <v-container>
    <!-- Otros elementos del login -->
    <v-carousel v-if="quotes.length" cycle hide-delimiter-background height="100" class="mt-5" hide-delimiters :show-arrows="false">
      <v-carousel-item v-for="(quote, index) in quotes" :key="index">
        <div class="px-4">
          <blockquote class="text-h6 font-italic mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:20px;" fill="currentColor" aria-hidden="true">
                <path d="M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z"/>
            </svg>
            <br/>
            {{ quote.text }}
          </blockquote>
          <div class="text-subtitle-2">— {{ quote.author }}</div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Carousel',
  setup() {
    const quotes = [
        { "text": "El éxito es la suma de pequeños esfuerzos repetidos cada día.", "author": "Robert Collier" },
        { "text": "No esperes a las oportunidades, créalas.", "author": "George Bernard Shaw" },
        { "text": "Haz hoy lo que otros no quieren, y mañana vivirás como otros no pueden.", "author": "Jerry Rice" },
        { "text": "La disciplina es el puente entre las metas y los logros.", "author": "Jim Rohn" },
        { "text": "Vender no es empujar, es ayudar a tomar decisiones.", "author": "Zig Ziglar" },
        { "text": "Cuanto más difícil sea la victoria, mayor será la felicidad de ganar.", "author": "Pelé" },
        { "text": "El éxito en ventas comienza con la actitud correcta.", "author": "Brian Tracy" },
        { "text": "Los grandes logros requieren tiempo y constancia.", "author": "Napoleón Hill" },
        { "text": "Nunca pospongas algo que puedas cerrar hoy.", "author": "Desconocido" },
        { "text": "No cierres una venta, abre una relación.", "author": "Patricia Fripp" },
        { "text": "Haz de cada interacción con un cliente una experiencia memorable.", "author": "Shep Hyken" },
        { "text": "Si no crees en lo que vendes, nadie más lo hará.", "author": "Desconocido" },
        { "text": "El fracaso es solo la oportunidad de comenzar de nuevo con más inteligencia.", "author": "Henry Ford" },
        { "text": "No se trata de tener tiempo, se trata de hacer tiempo.", "author": "Desconocido" },
        { "text": "El CRM no vende por ti, pero te dice a quién venderle mejor.", "author": "Desconocido" },
        { "text": "Las excusas no venden. Las acciones sí.", "author": "Desconocido" },
        { "text": "Convierte tus problemas en planes y tus planes en resultados.", "author": "Robin Sharma" },
        { "text": "No te detengas hasta estar orgulloso.", "author": "Desconocido" },
        { "text": "Tu actitud, no tu aptitud, determinará tu altitud.", "author": "Zig Ziglar" },
        { "text": "Las metas claras llevan a resultados claros.", "author": "Tony Robbins" },
        { "text": "Un seguimiento vale más que mil propuestas.", "author": "Desconocido" },
        { "text": "La confianza se construye mostrando resultados.", "author": "Desconocido" },
        { "text": "Todo vendedor exitoso fue principiante alguna vez.", "author": "Desconocido" },
        { "text": "Haz seguimiento como si tu comisión dependiera de ello. Porque así es.", "author": "Desconocido" },
        { "text": "Los datos son el nuevo oro. Úsalos.", "author": "Desconocido" },
        { "text": "Un ERP ordenado es un equipo enfocado.", "author": "Desconocido" },
        { "text": "El cliente no siempre tiene la razón, pero siempre tiene la decisión.", "author": "Desconocido" },
        { "text": "La persistencia vence la resistencia.", "author": "Desconocido" },
        { "text": "La motivación es lo que te hace empezar, el hábito es lo que te mantiene.", "author": "Jim Ryun" },
        { "text": "La clave está en servir, no solo en vender.", "author": "Desconocido" },
        { "text": "Las oportunidades no se esperan, se construyen.", "author": "Chris Grosser" },
        { "text": "El CRM no olvida, tú sí. Úsalo.", "author": "Desconocido" },
        { "text": "Una pequeña mejora diaria, a la larga, da grandes resultados.", "author": "Desconocido" },
        { "text": "El verdadero líder no empuja, inspira.", "author": "John C. Maxwell" },
        { "text": "Cierra menos, conecta más.", "author": "Desconocido" },
        { "text": "No necesitas más tiempo, necesitas más enfoque.", "author": "Desconocido" },
        { "text": "Si no estás mejorando, estás retrocediendo.", "author": "Desconocido" },
        { "text": "Sé tan bueno que no puedan ignorarte.", "author": "Steve Martin" },
        { "text": "No hay límites, solo decisiones.", "author": "Tony Robbins" },
        { "text": "Haz lo difícil mientras es fácil.", "author": "Lao Tzu" },
        { "text": "El miedo no detiene al vendedor, lo impulsa.", "author": "Desconocido" },
        { "text": "Una llamada más puede ser la que cierre el mes.", "author": "Desconocido" },
        { "text": "Nunca subestimes el poder de una buena presentación.", "author": "Desconocido" },
        { "text": "Sin seguimiento, no hay cierre.", "author": "Desconocido" },
        { "text": "Todo sistema es tan bueno como las personas que lo usan.", "author": "Desconocido" },
        { "text": "No se trata de trabajar más, sino de trabajar mejor.", "author": "Desconocido" },
        { "text": "Haz de tu jornada un entrenamiento, no una tortura.", "author": "Desconocido" },
        { "text": "Cada cliente tiene una historia, escúchala.", "author": "Desconocido" },
        { "text": "Los retos son oportunidades disfrazadas.", "author": "Desconocido" },
        { "text": "La productividad comienza con claridad.", "author": "Desconocido" },
        { "text": "Tu mejor herramienta es tu actitud.", "author": "Desconocido" },
        { "text": "El mejor momento para empezar fue ayer. El segundo mejor es hoy.", "author": "Desconocido" },
        { "text": "No vendas el producto, vende el beneficio.", "author": "Desconocido" },
        { "text": "Las metas no sirven sin acción.", "author": "Desconocido" },
        { "text": "Sé la solución, no una opción.", "author": "Desconocido" },
        { "text": "Confía en el proceso.", "author": "Desconocido" },
        { "text": "Conócete, conéctate, convierte.", "author": "Desconocido" },
        { "text": "La mejor venta empieza con una buena pregunta.", "author": "Desconocido" },
        { "text": "Cada día es una nueva oportunidad de mejorar.", "author": "Desconocido" },
        { "text": "Haz más de lo que funciona, menos de lo que no.", "author": "Desconocido" },
        { "text": "Vende como si ya te hubieran dicho que sí.", "author": "Desconocido" },
        { "text": "Escucha más de lo que hablas.", "author": "Desconocido" },
        { "text": "Una CRM limpia es una mente clara.", "author": "Desconocido" },
        { "text": "Cree en tu solución, antes de ofrecerla.", "author": "Desconocido" },
        { "text": "La venta empieza cuando el cliente dice 'no'.", "author": "Desconocido" },
        { "text": "Transforma datos en decisiones.", "author": "Desconocido" },
        { "text": "Hazlo con pasión o no lo hagas.", "author": "Desconocido" },
        { "text": "El compromiso vence al talento cuando el talento no se compromete.", "author": "Desconocido" },
        { "text": "Deja que tu trabajo hable por ti.", "author": "Desconocido" },
        { "text": "La competencia se entrena, la actitud se elige.", "author": "Desconocido" },
        { "text": "Cada venta es un paso más cerca de tu meta.", "author": "Desconocido" },
        { "text": "No solo cierres tratos, abre puertas.", "author": "Desconocido" },
        { "text": "Una herramienta poderosa en manos inactivas es inútil.", "author": "Desconocido" },
        { "text": "Vender con integridad siempre gana a largo plazo.", "author": "Desconocido" },
        { "text": "No es magia, es estrategia.", "author": "Desconocido" },
        { "text": "Convierte los problemas en propuestas de valor.", "author": "Desconocido" },
        { "text": "El seguimiento es la mitad de la venta.", "author": "Desconocido" },
        { "text": "El éxito diario es la suma de pequeñas victorias.", "author": "Desconocido" },
        { "text": "Da más de lo que prometes, siempre.", "author": "Desconocido" },
        { "text": "Una agenda vacía es una oportunidad perdida.", "author": "Desconocido" },
        { "text": "Organiza tu CRM como si tu bono dependiera de ello. Porque lo hace.", "author": "Desconocido" },
        { "text": "Si no puedes medirlo, no puedes mejorarlo.", "author": "Peter Drucker" },
        { "text": "La gente no compra productos, compra historias.", "author": "Desconocido" },
        { "text": "Detrás de cada venta hay confianza. Gánatela.", "author": "Desconocido" },
        { "text": "Apunta al progreso, no a la perfección.", "author": "Desconocido" },
        { "text": "Trabaja duro en silencio, deja que tu éxito haga ruido.", "author": "Frank Ocean" }
        ]

    const randomQuote = ref(quotes[Math.floor(Math.random() * quotes.length)]);

    return {
      quotes,
    };
  },
});
</script>
